export default "__VITE_ASSET__Cinnyz9Y__"